import React from 'react';

import type { AccordionItemProps, MelodyAccordionProps } from 'components/common/MelodyAccordion';
import { MelodyAccordion, MelodyAccordionItem } from 'components/common/MelodyAccordion';

import css from 'styles/components/landing/landingPageAccordion.scss';

export const LandingPageAccordionItem = (props: AccordionItemProps) => (
  <MelodyAccordionItem {...props} accordionRegionContainerStyleOverride={css.landingPageAccordionItem} />
);

export const LandingPageAccordion = (props: MelodyAccordionProps) => {
  const { children } = props;
  return <MelodyAccordion {...props}>{children}</MelodyAccordion>;
};
